import { Button, Flex, FlexProps, Logo, Typography } from '@aloft/toolkit-sui';
import { useAuth0 } from '@auth0/auth0-react';

import { useBreakpoints } from '../hooks/useBreakpoints.ts';

type Props = React.PropsWithChildren<{
  title?: string;
  description?: string;
  bodyProps?: FlexProps;
}>;

export const UnsubscribedViewLayout = ({ title, description, bodyProps = {}, children }: Props) => {
  const { logout } = useAuth0();
  const { isMobileAndBelow } = useBreakpoints();

  return (
    <Flex
      minHeight="100%"
      width="100%"
      padding={isMobileAndBelow ? '12px 24px' : '8px 16px'}
      flexDirection="column"
    >
      <Flex justifyContent="space-between" width="100%">
        <Logo width={50} height={50} />
        {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
        <Button size="sm" variant="secondary" onClick={() => logout()} text="Logout" />
      </Flex>
      <Flex
        flexDirection="column"
        alignItems="center"
        paddingTop="32px"
        gap="24px"
        width="100%"
        flexGrow={1}
        {...bodyProps}
      >
        {!!title && <Typography variant="h1">{title}</Typography>}
        {!!description && <Typography>{description}</Typography>}
        {children}
      </Flex>
    </Flex>
  );
};
